import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Reverberations",
  date: new Date(2024, 10, 10),
  img: "/img/polar-bear.jpeg",
  tracks: [
    {
      title: "Waiting For The Wind",
      src: "/songs/2024-11-10/waiting_for_the_wind.mp3",
      duration: 2018.736,
    },
    {
      title: "No Tears Are Comin'",
      src: "/songs/2024-11-10/no_tears_are_comin.mp3",
      duration: 849.768,
    },
    {
      title: "The Tim Waltz",
      src: "/songs/2024-11-10/the_tim_waltz.mp3",
      duration: 493.464,
    },
    {
      title: "Hiding Secrets",
      src: "/songs/2024-11-10/hiding_secrets.mp3",
      duration: 414.72,
    },
    {
      title: "And Then We Hey!",
      src: "/songs/2024-11-10/and_then_we_hey.mp3",
      duration: 558,
    },
    {
      title: "Absolute Zero",
      src: "/songs/2024-11-10/absolute_zero.mp3",
      duration: 499.416,
    },
    {
      title: "Bipolar Bear",
      src: "/songs/2024-11-10/bipolar_bear.mp3",
      duration: 802.92,
    },
    {
      title: "Midtown Hoedown",
      src: "/songs/2024-11-10/midtown_hoedown.mp3",
      duration: 667.248,
    },
    {
      title: "Bridge Of Insanity",
      src: "/songs/2024-11-10/bridge_of_insanity.mp3",
      duration: 862.344,
    },
    {
      title: "Escape From Southeast Portland",
      src: "/songs/2024-11-10/escape_from_se_pdx.mp3",
      duration: 941.376,
    },
    {
      title: "Arabian Horses",
      src: "/songs/2024-11-10/arabian_horses.mp3",
      duration: 1181.688,
    },
    {
      title: "Easing Into Twilight",
      src: "/songs/2024-11-10/easing_into_twilight.mp3",
      duration: 1097.472,
    },
  ],
};
export default album;
